import * as R from 'ramda'
import {
  put,
  all,
  fork,
} from 'redux-saga/effects'
import { createNamedAction } from 'helpers/ActionUtil'

import injectSagas from 'helpers/injectSagas'
import {
  createTakeEveryName,
} from 'helpers/SagaUtil'
import {
  UPDATE_VALUE,
} from 'containers/Form/Input/constants'
import {
  updateValidationValue
} from 'containers/Form/Validation/actions'
import {
  getPath
} from 'containers/Form/util'

function loadSagas(pathName, elementId) {
  const path = getPath(pathName, elementId)
  const takeEveryName = createTakeEveryName(path)
  const updateValidationValueAction = createNamedAction(path, updateValidationValue)

  function* handleValueChange() {
    yield put(updateValidationValueAction())
  }

  function* watchValueChange() {
    yield takeEveryName(UPDATE_VALUE, handleValueChange)
  }

  function* sagas() {
    yield all([
      fork(watchValueChange),
    ])
  }

  return injectSagas({ [path]: sagas })
}

export default loadSagas
